<script>
import {mapActions} from "vuex";
import "swiper/dist/css/swiper.css";

export default {
  name: "changePassword",
  data() {
    return {
      displayPassword: false,
      passwordCheckDialogVisible: false,
      passwordResetDialogVisible: false,
      viewCurrentPassword: false,
      viewNewPassword: false,
      viewConfirmPassword: false,
      matchPasswordDialogForm: {
        password: ""
      },
      changePasswordDialogForm: {
        newPassword: "",
        confirmPassword: ""
      },
      isPasswordMatch: false,
      formRules: {
        password: [{required: true, message: 'Password required'}],
        newPassword: [{required: true, message: 'New password required'}],
        confirmPassword: [{required: true, message: 'Confirm password required'}]
      },
    }
  },

  created() {
    var that = this;
  },
  beforeUpdate() {

  },
  methods: {
    ...mapActions("account", [
      "matchPassword",
      "changePassword"
    ]),
    handleCloseCheckPassword() {
      this.passwordCheckDialogVisible = false;
    },
    handleCloseResetPassword() {
      this.passwordResetDialogVisible = false;
    },
    toggleDisplayCheckPassword() {
      this.passwordCheckDialogVisible = true;
    },
    toggleDisplayChangePassword() {
      this.passwordResetDialogVisible = true;
    },
    checkCurrentPassword() {
      console.log("check current password");
      var that = this;
      that.matchPassword({
        params: {password: this.matchPasswordDialogForm.password},
        callback: that.checkPasswordCallback
      });
    },
    validatePasswords() {
      this.isPasswordMatch = this.newPassword === this.confirmPassword;
    },
    updatePassword() {
      console.log("update password");
      var that = this;
      this.changePassword({
        params: {
          newPassword: this.changePasswordDialogForm.newPassword,
          confirmNewPassword: this.changePasswordDialogForm.confirmPassword
        },
        callback: that.changePasswordCallback
      });
    },
    checkPasswordCallback(res) {
      console.log("callback check password");
      var that = this;
      if (res.data.code == 0) {
        this.handleCloseCheckPassword();
        this.toggleDisplayChangePassword();

      } else if (res.data.code == 10000 ||
        res.data.code == 40013
      ) {
        that.$box.alert("", "Incorrect password.", "error");
      } else if (res.data.code == 70010) {

      } else if (res.data.code == 40007) {

      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }

    },
    changePasswordCallback(res) {
      console.log("callback change password");
      var that = this;
      if (res.data.code == 0) {
        that.$box.alert("", "Password successfully changed", "success");
        this.handleCloseResetPassword();
      } else if (res.data.code == 10000 ||
        res.data.code == 40013 ||
        res.data.code == 40014
      ) {
        that.$box.alert("", "New passwords do not match.", "error");
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {

      } else {
        that.$box.alert("", res.data.message, "error");
      }

    }
  },

};
</script>

<template>
  <div>
    <el-button
      class="change-password-btn"
      type="text"
      @click="toggleDisplayCheckPassword"
    >
      Change Password
    </el-button>

    <!-- Current Password Dialog -->
    <el-dialog
      class="dialog-change-pw"
      :before-close="handleCloseCheckPassword"
      :visible.sync="passwordCheckDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="90%"
    >
      <span slot="title" class="dialog-title">Change Password</span>
      <el-form
        :model="matchPasswordDialogForm"
        :rules="formRules"
        label-width="auto"
        class="dialog-form"
      >
        <el-form-item prop="password">
          <span class="form-label">Current Password</span>
          <el-input class="input-group-pw"
                    v-model="matchPasswordDialogForm.password"
                    placeholder="Password"
                    :type="viewCurrentPassword ? 'text' : 'password'"
          >
            <template slot="prepend">
              <i class="el-icon-lock"/>
            </template>
            <template v-if="!viewCurrentPassword" slot="append">
              <i class="el-icon-view" @click="viewCurrentPassword = !viewCurrentPassword"/>
            </template>
            <template v-if="viewCurrentPassword" slot="append">
              <!--              <i>-->
              <img class="icon-hide" src="../../../assets/el-icon-hide.svg"
                   @click="viewCurrentPassword = !viewCurrentPassword"/>
              <!--              </i>-->
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="btn-change-pw"
          @click="checkCurrentPassword"
        >
          Next
        </el-button>
      </span>
    </el-dialog>
    <!-- End Current Password Dialog-->

    <!-- Reset Password Dialog -->
    <el-dialog
      class="dialog-change-pw"
      :before-close="handleCloseResetPassword"
      :visible.sync="passwordResetDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="90%"
    >
      <span slot="title" class="dialog-title">Change Password</span>
      <el-form
        :model="changePasswordDialogForm"
        :rules="formRules"
        label-width="auto"
        class="dialog-form"
      >
        <el-form-item prop="newPassword">
          <span class="form-label">New Password</span>
          <el-input class="input-group-pw"
                    v-model="changePasswordDialogForm.newPassword"
                    placeholder="New Password"
                    :type="viewNewPassword ? 'text' : 'password'"
                    @input="validatePasswords"
          >
            <template slot="prepend">
              <i class="el-icon-lock"/>
            </template>
            <template v-if="!viewNewPassword" slot="append">
              <i class="el-icon-view" @click="viewNewPassword = !viewNewPassword"/>
            </template>
            <template v-if="viewNewPassword" slot="append">
              <img class="icon-hide" src="../../../assets/el-icon-hide.svg"
                   @click="viewNewPassword = !viewNewPassword"/>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <span class="form-label">Confirm Password</span>
          <el-input class="input-group-pw"
                    v-model="changePasswordDialogForm.confirmPassword"
                    placeholder="Confirm Password"
                    :type="viewConfirmPassword ? 'text' : 'password'"
                    @input="validatePasswords"
          >
            <template slot="prepend">
              <i class="el-icon-lock"/>
            </template>
            <template v-if="!viewConfirmPassword" slot="append">
              <i class="el-icon-view" @click="viewConfirmPassword = !viewConfirmPassword"/>
            </template>
            <template v-if="viewConfirmPassword" slot="append">
              <img class="icon-hide" src="../../../assets/el-icon-hide.svg"
                   @click="viewConfirmPassword = !viewConfirmPassword"/>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="btn-change-pw"
          :disabled="!isPasswordMatch"
          @click="updatePassword"
        >
          Save
        </el-button>
      </span>
    </el-dialog>
    <!-- End Reset Password Dialog-->
  </div>
</template>
<style lang="scss" scoped>

.el-dialog__wrapper {
  margin: auto !important;
}

.icon-hide {
  padding-top: 2px;
  filter: invert(64%) sepia(13%) saturate(131%) hue-rotate(182deg) brightness(90%) contrast(87%);
  height: 28px;
}

.change-password-btn {
  border-bottom: 2px solid #003333;
  padding-bottom: 2px;
  border-radius: 0;
  color: #003333;
  font: 600 16px DINosaur-a, sans-serif;
}

.dialog-change-pw {
  margin-top: 15vh !important;
  max-width: 90%;
}

.dialog-title {
  font-size: 20px;
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-weight: 600;
  line-height: 1.2;
  display: flex;
  justify-content: start;
}

.dialog-form {
  max-width: 100%;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #003333;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.btn-change-pw {
  color: #ffffff;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 10px 30px;
  border-top-right-radius: 20px;
  font: 600 16px DINosaur-a, sans-serif;
}

.btn-save {
  font: 600 16px DINosaur-a, sans-serif;
}

@media (max-width: 600px) {
  .dialog-title {
    font-size: 18px;
  }

  .form-label {
    font-size: 12px;
  }

  .btn-change-pw, .btn-save {
    padding: 12px 20px;
    font-size: 14px;
  }
  .icon-hide {
    height: 19px;
  }
}

.input-group-pw {
  line-height: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/profile/components/changePassword.vue